import React, { Component } from "react";
import { Notification, TextInputSkeleton, TextInput } from "carbon-components-react";
import { withRouter } from "../../ComponentWithRouterProp";

import { onStateChange } from "events";
import "./modal.scss";
import moment from "moment";
import ModalHelpers from "./ModalHelpers";
import UpdateStateHelper from "../../Components/FormBuilder/UpdateStateHelper";
import FormBuilderV2 from "../../Components/FormBuilder/FormBuilderV2";
import ErrorHelpers from "../../Components/FormBuilder/ErrorHelpers";
import { editActivationData, getPlatformAdvertisers } from "../../Flux/Actions/MasterCampaignActions";
import MasterCampaignsStore from "../../Flux/Stores/MasterCampaignsStore";
import BookFiltersStore from "../../Flux/Stores/BookFiltersStore";
import Loading from "../../Components/LoadingSpinner";
import Modal from "@acadia-ui/modal";
import Button from "@acadia-ui/button";
import "./EditActivationPlatformV2.scss";
import Dropdown from "@acadia-ui/dropdown";
import Textbox from "@acadia-ui/textbox";
import { showToast, ToastNotification, TOAST_TYPE } from "@acadia-ui/toast";
import AccessPermissions from "../../Components/FormBuilder/AccessPermissions";

const initialState = {
	formData: {},
	postData: {},
	errors: {},
	showErrors: false,
	isFormDataValid: false
};

const formEl = "edit__activation";

class EditActivationPlatformV2 extends Component {
	constructor(props) {
		super(props);
		this.state = { metaData: {}, loading: false, open: false, ...initialState, permissionedOptions: {}, advertiserName: null, advertiser: null };
	}

	componentDidUpdate(prevProps) {
		if (prevProps.data != this.props.data) {
			const { MasterPlatformID, PlatformCampaignPK, ExternalSystemStatusID } = this.props.data;
			if (MasterPlatformID == "2" && PlatformCampaignPK && ["2", "3", "4", "6"].includes(ExternalSystemStatusID)) {
				this.setState({ metaData: { ...this.state.metaData, StartDate: moment().format("YYYY/MM/DD") } });
			} else {
				const { StartDate, ...rest } = this.state.metaData;
				this.setState({ metaData: rest });
			}
		}
	}

	componentDidMount() {
		this.props.editRef(this);
		MasterCampaignsStore.on("edit_error_activation", this.handleErrors);
		MasterCampaignsStore.on("edit_activation_success", this.handleSuccess);
		MasterCampaignsStore.on("activation__errors__reset", this.handleReset);
	}

	componentWillUnmount() {
		this.props.editRef(undefined);
		MasterCampaignsStore.removeListener("edit_error_activation", this.handleErrors);
		MasterCampaignsStore.removeListener("edit_activation_success", this.handleSuccess);
		MasterCampaignsStore.removeListener("activation__errors__reset", this.handleReset);
	}

	handleSuccess = () => {
		showToast(
			"masterCampaignToasts",
			<ToastNotification type={TOAST_TYPE.SUCCESS} message="The selected activation campaign information has been successfully updated." timed={5000} />
		);
		MasterCampaignsStore.resetClonedActivationCampaign();
		MasterCampaignsStore.resetSelectedCampaigns();
		this.triggerOpenClose();
		this.props.refresh();
	};

	handleReset = () => {
		ErrorHelpers.resetErrors(formEl);
	};

	handleErrors = () => {
		this.setState({ loading: false }, () => {
			const errors = MasterCampaignsStore.getErrors();
			if (Object.keys(errors).length > 0) {
				const activationErrors = errors.activation;
				const type = "edit activationplatform";
				this.setState({ errors: activationErrors, showErrors: true }, () => {
					ErrorHelpers.displayErrors(formEl, this.state.errors, type);
				});
			}
		});
	};

	isValidFormData = () => {
		const { formData } = this.state;
		let isValid = true;
		for (const key in formData) {
			if (Object.hasOwn(formData, key)) {
				const { value } = formData[key];
				const isDisabled = formData[key].disabled;
				if ((value == "" || value == null || value == undefined) && !isDisabled) {
					isValid = false;
				}
			}
		}
		if (Object.keys(this.props.permissionedDataKeys).length) {
			const selectedPermissions = [];
			Object.values(this.state.permissionedOptions).forEach((dataValues) => {
				selectedPermissions.push(...dataValues);
			});
			if (!selectedPermissions.length) {
				isValid = false;
			}
		}

		this.setState({ isFormDataValid: isValid });
	};

	updateState = (dataConfig, name, value, id, dataType, calc, disabled, disableDelete = false) => {
		if (this.state.loading === false) {
			// The reference to THIS is used to update the proper state
			// dataConfig, name, value, id, dataType, calc, formEl, self, disabled
			UpdateStateHelper.update(dataConfig, name, value, id, dataType, true, formEl, this, false, this.props.config, disableDelete, this.isValidFormData);
		}
	};

	sendPostObject = (newRowObj) => {
		this.postObject = this.formDataObjForPost(newRowObj);
		if (this.postObject) {
			const updatedData = editActivationData(this.postObject, this.props.onSubmitComplete);
		}
		if (this.postObject === undefined) {
			this.setState({ loading: false });
		}
	};

	sortTaxonomyData = (taxonomyData) => {
		const taxDataWithPositions = taxonomyData;
		taxDataWithPositions.forEach((taxonomyField) => {
			if (this.props.config.TaxonomyData) {
				this.props.config.TaxonomyData.forEach((taxFieldConfig) => {
					if (taxFieldConfig.ID === taxonomyField.dataKeyID) {
						taxonomyField.Position = taxFieldConfig.Position;
					}
				});
			}
		});
		taxDataWithPositions.sort((a, b) => {
			if (a.Position < b.Position) {
				return -1;
			}
			if (a.Position > b.Position) {
				return 1;
			}
			return 0;
		});
		taxDataWithPositions.forEach((taxonomyField) => {
			delete taxonomyField.Position;
		});
		return taxDataWithPositions;
	};

	/* This should be a helper object that formats POST JSON for the PUT Actions */
	formDataObjForPost = (newRowObj) => {
		if (Object.keys(newRowObj).length > 0) {
			const postData = { ...this.state.postData };
			let strippedTaxonomyPostData = [];

			/* Removes the Key from the Taxonomy Data Array : Theja's Post does not like it */
			for (const i in postData.TaxonomyData) {
				strippedTaxonomyPostData.push(postData.TaxonomyData[i]);
			}
			strippedTaxonomyPostData = this.sortTaxonomyData(strippedTaxonomyPostData);
			const strippedMetadataPostData = [];
			for (const i in postData.MetaData) {
				strippedMetadataPostData.push(postData.MetaData[i]);
			}
			postData.MetaData = strippedMetadataPostData;
			/* postData is a copy of the state, so we just overwrite the innards with our new array */
			postData.TaxonomyData = strippedTaxonomyPostData;
			if (postData.CampaignData) {
				postData.CampaignData.CampaignID = this.props.data.CampaignUniqueCode;
				postData.CampaignData.MasterCampaignID = this.props.data.ParentUniqueIDcode;
				postData.CampaignData.MasterPlatformID = this.props.data.MasterPlatformID;
				if (this.props.data.PlatformAdvertiserID !== null) {
					postData.CampaignData.PlatformAdvertiserID = this.props.data.PlatformAdvertiserID;
				}
			}

			const permissionedOptions = [];
			Object.keys(this.state.permissionedOptions).forEach((dataKey) => {
				this.state.permissionedOptions[dataKey].forEach((option) => {
					permissionedOptions.push(option.DataValue_MDM_GUID);
				});
			});
			postData.CampaignData.DataValue_MDM_GUIDs = permissionedOptions.join();

			if (this.state.advertiser) {
				postData.CampaignData.PlatformAdvertiserID = this.state.advertiser.value;
			}

			postData.PlatformID = this.props.data.MasterPlatformID;
			postData.IsDraft = this.props.data.IsDraft;
			const filters = BookFiltersStore.getChoicesState();
			const MasterUniqueCodeID = MasterCampaignsStore.getMasterCampaignUniqueID();
			/* Config will hold the ID's of the filters */
			// const PlatformID = filters.platform.value;
			// const auditlevelID = filters.auditlevel.value;

			const contextValues = BookFiltersStore.getContextValues();
			const formSubmissionObj = {
				MasterAgencyDivisionName: contextValues?.agency?.name,
				MasterBusinessUnitName: contextValues?.client?.name,
				MasterCountryCode: contextValues?.country?.name,
				MasterRegionCode: contextValues?.region?.name,
				AuditLevelID: this.props.data.HierarchyLevelID,
				ContextID: contextValues.contextId,
				CampaignID: postData.CampaignData.CampaignID,
				// add here
				...postData
			};

			if (formSubmissionObj?.CampaignData?.KPIGoalDetails?.includes?.("%")) {
				formSubmissionObj.CampaignData.KPIGoalDetails = formSubmissionObj.CampaignData.KPIGoalDetails.replace("%", "");
			}

			return formSubmissionObj;
		}
		this.setState({ errors: { Errors: ["Please fill in all form fields."] }, showErrors: true }, () => {
			ErrorHelpers.displayErrors(formEl, this.state.errors);
		});
	};

	/* Needed for all Modals */
	triggerOpenClose = (event) => {
		if (this.state.loading === false) {
			ModalHelpers.openClose(event, this.updateModalState, this.state, initialState, () => {
				ErrorHelpers.resetErrors(formEl);
				if (this.state.open === false) {
					this.setState({ loading: true, permissionedOptions: {} }, () => {
						this.fillFields();
					});
				}
			});
		}
	};

	handleParentReset = (callback) => {
		if (callback) {
			this.setState({ ...initialState }, callback());
		} else {
			this.setState({ ...initialState });
		}
	};

	fillFields = () => {
		this.handleParentReset();
		this.matchData();
		this.matchPermissionedOptions();
		this.displayAdvertiserName();
		// This is the line that might be needed to signify that this is an edit and not a create, depending on the endpoint
	};

	matchPermissionedOptions = () => {
		const permissionedOptions = {};
		const selectedOptions = this.props.data?.DataValue_MDM_GUIDs?.split(",");
		Object.keys(this.props.permissionedDataKeys).forEach((dataKey) => {
			this.props.permissionedDataKeys[dataKey].forEach((option) => {
				if (selectedOptions.includes(option.DataValue_MDM_GUID)) {
					if (!permissionedOptions[dataKey]) {
						permissionedOptions[dataKey] = [option];
					} else {
						permissionedOptions[dataKey] = [...permissionedOptions[dataKey], option];
					}
				}
			});
		});
		this.setState({ permissionedOptions });
	};

	displayAdvertiserName = () => {
		this.setState({ advertiserName: null, advertiser: null }, () => {
			if (this.props.data?.MasterPlatformID !== "5") {
				MasterCampaignsStore.resetPlatformAdvertisers();
				getPlatformAdvertisers({ masterPlatformID: this.props.data?.MasterPlatformID }).then(() => {
					// If this campaign has a previously selected advertiser, display the name
					// Otherwise, display a dropdown that allows users to select an advertiser
					if (this.props.data?.PlatformAdvertisers) {
						try {
							const selectedAdvertiser = JSON.parse(this.props.data?.PlatformAdvertisers)?.[0];
							const matchingAdvertiser = MasterCampaignsStore.getPlatformAdvertisers().find((advertiser) => {
								return advertiser.value === selectedAdvertiser.PlatformAdvertiserID;
							});
							if (matchingAdvertiser) {
								this.setState({ advertiserName: matchingAdvertiser.label });
							}
						} catch (e) {
							console.log("error occured matching advertiser", e);
						}
					} else {
						this.setState({ advertiser: null });
					}
				});
			}
		});
	};

	matchData = () => {
		this.handleReset();
		const fieldArray = [];
		const configObjs = Object.entries(this.props.config);
		for (const dataBucket of configObjs) {
			for (const field of dataBucket[1]) {
				if (this.props.data.hasOwnProperty(field.Name)) {
					if (field.DataType === "Select") {
						let optionID = this.props.data[`${field.Name}ID`];
						let fieldLabel = this.props.data[field.Name];
						const fieldItem = dataBucket[1].filter((a) => a.Name == field.Name);
						if (fieldItem.length > 0) {
							const optionItem = fieldItem[0].Options.filter((a) => a.OptionLabel == this.props.data[field.Name]);
							if (optionItem.length > 0) {
								optionID = optionItem[0].OptionID;
							}
						}

						if (optionID === undefined) {
							let dataValueID = null;
							const previousTaxonomyData = this.props.data.TaxonomyData ? JSON.parse(this.props.data.TaxonomyData) : [];
							const previousMetaData = this.props.data.MetaData ? JSON.parse(this.props.data.MetaData) : [];
							previousTaxonomyData.forEach((taxonomyField) => {
								if (taxonomyField.DataKeyShortDescr === field.Label) {
									if (taxonomyField.DataValue) {
										dataValueID = taxonomyField.DataValue.DataValueID;
									}
								}
							});
							if (dataValueID === null) {
								previousMetaData.forEach((metaDataField) => {
									if (metaDataField.DataKeyShortDescr === field.Label) {
										if (metaDataField.DataValue) {
											dataValueID = metaDataField.DataValue.DataValueID;
										}
									}
								});
							}
							if (dataValueID !== null) {
								const changedMatchingOption = field.Options.filter((option) => option.OptionID === dataValueID.toString());
								if (changedMatchingOption[0] !== undefined) {
									optionID = changedMatchingOption[0].OptionID;
									fieldLabel = changedMatchingOption[0].OptionLabel;
								}
							}
						}

						// Populate Drop Down Fields
						// There are only 7 Parameters accepted: see updateState below to match
						if (optionID != undefined && optionID > 0) {
							fieldArray.push([dataBucket[0], field.Name, { value: optionID, label: fieldLabel }, field.ID, field.DataType, true]);
						}
					} else {
						// Populate Free Text Fields
						// There are only 7 Parameters accepted: see updateState below to match
						fieldArray.push([dataBucket[0], field.Name, this.props.data[field.Name], field.ID, field.DataType, false]);
					}
				}
			}
		}
		// The reference to THIS is used to update the proper state
		UpdateStateHelper.bulkUpdate(fieldArray, this.props.config, this, this.fieldsFilled);
	};

	fieldsFilled = () => {
		const { postData } = this.state;
		if (postData.CampaignData) {
			postData.CampaignData.CampaignUniqueIDCode = this.props.data.CampaignUniqueIDCode;
		} else {
			postData.CampaignData = {};
			postData.CampaignData.CampaignUniqueIDCode = this.props.data.CampaignUniqueIDCode;
		}
		this.setState({ postData, loading: false });
	};

	updateModalState = () => {
		this.setState({ open: !this.state.open, ...initialState }, () => {
			if (this.state.open) {
			} else {
				this.props?.onClose?.();
			}
		});
	};
	/* END */

	handleSubmit = (e) => {
		if (this.state.loading === false) {
			this.setState({ loading: true }, () => {
				e.preventDefault();
				/* Server Side Validation */
				this.sendPostObject(this.state.formData);
			});
		}
	};

	render() {
		const isDisabled = this.state.loading ? "disabledModal" : "";
		/* Temp Test Function -- Loads a skeleton if nothing there yet */
		const filters = BookFiltersStore.getChoicesState();
		const platformName = filters.platform.label;
		let formInnards;
		if (Object.keys(this.props.config).length !== 0) {
			let conf = this.props.config;
			if (this.props.data.IsPrismaBudgetLocked == "True") {
				conf = JSON.parse(JSON.stringify(this.props.config));
				conf.CampaignData.find(({ Name }) => Name == "Budget").IsReadOnly = true;
			}

			formInnards = <FormBuilderV2 type="edit activationplatform" data={conf} configName="ActivationPlatform" onUpdate={this.updateState} state={this.state} />;
		} else {
			formInnards = (
				<div>
					<TextInputSkeleton />
					<br />
					<TextInputSkeleton hideLabel />
				</div>
			);
		}

		return (
			<>
				<Modal
					id="edit__activation"
					heading="Edit Activation Campaign"
					description="Modify the activation campaign information. Click 'Save' to apply the changes instantly."
					isOpen={this.state.open}
					onRequestClose={() => {
						if (this.state.open) {
							this.triggerOpenClose();
						}
					}}
					userClosable={true}
					onClick={() => {}}
					size="medium"
					actionSetProps={{
						actionsRight: (
							<>
								<Button display="secondary" onClick={this.triggerOpenClose} data-tracking-id-alt="cancel-edit-activation-platform">
									Cancel
								</Button>
								<Button
									display="primary"
									disabled={!this.state.isFormDataValid}
									onClick={this.handleSubmit}
									data-tracking-id-alt="confirm-edit-activation-platform"
								>
									Save
								</Button>
							</>
						)
					}}
				>
					{this.state.loading && <Loading className="modalLoading" />}
					<form autoComplete="off" className="activation-campaign-fields-container">
						<Dropdown className="select-activation-platform-dropdown" required="true" options={[filters.platform]} value={filters.platform} disabled={true}>
							Activation Platform
						</Dropdown>
						<AccessPermissions
							type="activation"
							permissionedOptions={this.state.permissionedOptions}
							masterCampaign={this.props.masterCampaign}
							onChange={(value, dataKey) => {
								const { permissionedOptions } = this.state;
								permissionedOptions[dataKey] = value;
								this.setState({ permissionedOptions }, () => {
									this.isValidFormData();
								});
							}}
						/>
						<div className="platform-fields">{formInnards}</div>
						{this.state.showErrors && <div id="errors__container" />}

						{this.state.advertiserName && (
							<div>
								<hr />
								<Textbox disabled={true} value={this.state.advertiserName}>
									Advertiser ({platformName})
								</Textbox>
							</div>
						)}
						{!this.state.advertiserName && MasterCampaignsStore.getPlatformAdvertisers()?.length > 0 && this.props.data?.MasterPlatformID !== "5" ? (
							<div>
								<hr />
								<Dropdown
									onChange={(advertiser) => {
										this.setState({ advertiser }, () => {
											this.isValidFormData();
										});
									}}
									placeholder="Select Platform Advertiser"
									options={MasterCampaignsStore.getPlatformAdvertisers()}
									isClearable={false}
									value={this.state.advertiser}
									isSearchable={true}
								>
									Advertiser {platformName}
								</Dropdown>
							</div>
						) : (
							<></>
						)}
					</form>
				</Modal>
			</>
		);
	}
}

export default withRouter(EditActivationPlatformV2);
